// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/selectArrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-parent-org .dropdown-menu[data-bs-popper] {
  margin-top: -5px;
  padding:5px 0;

}
    .dropdown-menu.show{
      border:none;
      box-shadow:0px 15px 30px -5px rgba(62, 62, 62, 0.1);     
    }
    .dropdown-toggle::after {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
      color: white;
      display: inline-block;
      margin-left: 0.255em;
      vertical-align: 0.255em;
      content: "";
      border-top: 0.3em solid;
      border-right: 0.3em solid transparent;
      border-bottom: 0;
      border-left: 0.3em solid transparent
    }
    .dropdown-menu.show a{
      margin: 0;
    }
    .navbar-dashboard{
      color:white !important;
    }
    .navbar-expand-lg {
      height: 100px;
    }
    .navbar-parent {
      display: flex !important;
      justify-content: center;
    }
    .navbar-parent a {
      display: flex;
      align-items: center;
      color: white !important;  
      text-decoration: none;
      width: 100px;
    }
    .navbar-parent a:hover {
      color: #68ad3f;
    }
    .nav-parent-org {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .navbar-toggler {
      border: none !important;
    }
    .navbar-toggler:focus {
      box-shadow: none;
    }
    .dropdown a {
      color: black !important;
      width: 100%;
    }
    .dropdown-toggle {
      color: white !important;
    }
    #offcanvasNavbarDropdown-expand-sm {
      color: white !important;
      text-transform: capitalize !important;
    }
    .dropdown-item.active,
    .dropdown-item:active {
      background-color: transparent;
    }
    .menu {
      padding: 5px 20px 5px 20px;
    }
    
    /* <---------------------------- media query for mpbile devices -------------------------------------> */
    @media only screen and (min-width: 0px) and (max-width: 560px) {
      .parent-mobile-nav {
        max-width: 70% !important;
        padding: 25px;
      }
      .navbar-parent {
        width: 100%;
      }
      #offcanvasNavbarDropdown-expand-sm {
        color: rgb(121, 121, 121) !important;
      }
      .navbar-parent a {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        text-decoration: none;
        height: 50px;
        width:100%;
        color: rgb(15, 15, 15) !important;
      }
      .nav-parent-org {
        width: 100%;
        padding: 20px 0px 20px 0px;
        display: flex;
        justify-content: space-between;
      }
      .navbar-dashboard{
        color:black !important;
      }
      .dropdown-menu[data-bs-popper] {
        margin-left: -15px;
      }
    }
    
    /* <---------------------------- media query for mpbile devices landscape orientation -------------------------------------> */
    @media only screen and (min-width: 561px) and (max-width: 767px) {
      .container,
      .container-sm {
        max-width: 100% !important;
      }
      .navbar-dashboard{
        color:black !important;
      }
  
    }
    
    /* <---------------------------- media query for ipad pro devices -------------------------------------> */
    @media only screen and (min-width: 767px) and (max-width: 2000px) {
  .parent-header{
    height:8vh;
    padding: 0px 36px !important;
  }
    }
    @media (min-width: 576px){
   .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
    left: unset;
    right: 10px;
}}
    `, "",{"version":3,"sources":["webpack://./src/Organizer/Headers/HeaderOrg.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;;AAEf;IACI;MACE,WAAW;MACX,mDAAmD;IACrD;IACA;MACE,yDAAqD;MACrD,YAAY;MACZ,qBAAqB;MACrB,oBAAoB;MACpB,uBAAuB;MACvB,WAAW;MACX,uBAAuB;MACvB,qCAAqC;MACrC,gBAAgB;MAChB;IACF;IACA;MACE,SAAS;IACX;IACA;MACE,sBAAsB;IACxB;IACA;MACE,aAAa;IACf;IACA;MACE,wBAAwB;MACxB,uBAAuB;IACzB;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,qBAAqB;MACrB,YAAY;IACd;IACA;MACE,cAAc;IAChB;IACA;MACE,WAAW;MACX,aAAa;MACb,yBAAyB;MACzB,mBAAmB;IACrB;IACA;MACE,uBAAuB;IACzB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,uBAAuB;MACvB,WAAW;IACb;IACA;MACE,uBAAuB;IACzB;IACA;MACE,uBAAuB;MACvB,qCAAqC;IACvC;IACA;;MAEE,6BAA6B;IAC/B;IACA;MACE,0BAA0B;IAC5B;;IAEA,wGAAwG;IACxG;MACE;QACE,yBAAyB;QACzB,aAAa;MACf;MACA;QACE,WAAW;MACb;MACA;QACE,oCAAoC;MACtC;MACA;QACE,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,qBAAqB;QACrB,YAAY;QACZ,UAAU;QACV,iCAAiC;MACnC;MACA;QACE,WAAW;QACX,0BAA0B;QAC1B,aAAa;QACb,8BAA8B;MAChC;MACA;QACE,sBAAsB;MACxB;MACA;QACE,kBAAkB;MACpB;IACF;;IAEA,8HAA8H;IAC9H;MACE;;QAEE,0BAA0B;MAC5B;MACA;QACE,sBAAsB;MACxB;;IAEF;;IAEA,0GAA0G;IAC1G;EACF;IACE,UAAU;IACV,4BAA4B;EAC9B;IACE;IACA;GACD;IACC,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf,CAAC","sourcesContent":[".nav-parent-org .dropdown-menu[data-bs-popper] {\n  margin-top: -5px;\n  padding:5px 0;\n\n}\n    .dropdown-menu.show{\n      border:none;\n      box-shadow:0px 15px 30px -5px rgba(62, 62, 62, 0.1);     \n    }\n    .dropdown-toggle::after {\n      background-image: url(\"../../Assets/selectArrow.png\");\n      color: white;\n      display: inline-block;\n      margin-left: 0.255em;\n      vertical-align: 0.255em;\n      content: \"\";\n      border-top: 0.3em solid;\n      border-right: 0.3em solid transparent;\n      border-bottom: 0;\n      border-left: 0.3em solid transparent\n    }\n    .dropdown-menu.show a{\n      margin: 0;\n    }\n    .navbar-dashboard{\n      color:white !important;\n    }\n    .navbar-expand-lg {\n      height: 100px;\n    }\n    .navbar-parent {\n      display: flex !important;\n      justify-content: center;\n    }\n    .navbar-parent a {\n      display: flex;\n      align-items: center;\n      color: white !important;  \n      text-decoration: none;\n      width: 100px;\n    }\n    .navbar-parent a:hover {\n      color: #68ad3f;\n    }\n    .nav-parent-org {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n    }\n    .navbar-toggler {\n      border: none !important;\n    }\n    .navbar-toggler:focus {\n      box-shadow: none;\n    }\n    .dropdown a {\n      color: black !important;\n      width: 100%;\n    }\n    .dropdown-toggle {\n      color: white !important;\n    }\n    #offcanvasNavbarDropdown-expand-sm {\n      color: white !important;\n      text-transform: capitalize !important;\n    }\n    .dropdown-item.active,\n    .dropdown-item:active {\n      background-color: transparent;\n    }\n    .menu {\n      padding: 5px 20px 5px 20px;\n    }\n    \n    /* <---------------------------- media query for mpbile devices -------------------------------------> */\n    @media only screen and (min-width: 0px) and (max-width: 560px) {\n      .parent-mobile-nav {\n        max-width: 70% !important;\n        padding: 25px;\n      }\n      .navbar-parent {\n        width: 100%;\n      }\n      #offcanvasNavbarDropdown-expand-sm {\n        color: rgb(121, 121, 121) !important;\n      }\n      .navbar-parent a {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        text-decoration: none;\n        height: 50px;\n        width:100%;\n        color: rgb(15, 15, 15) !important;\n      }\n      .nav-parent-org {\n        width: 100%;\n        padding: 20px 0px 20px 0px;\n        display: flex;\n        justify-content: space-between;\n      }\n      .navbar-dashboard{\n        color:black !important;\n      }\n      .dropdown-menu[data-bs-popper] {\n        margin-left: -15px;\n      }\n    }\n    \n    /* <---------------------------- media query for mpbile devices landscape orientation -------------------------------------> */\n    @media only screen and (min-width: 561px) and (max-width: 767px) {\n      .container,\n      .container-sm {\n        max-width: 100% !important;\n      }\n      .navbar-dashboard{\n        color:black !important;\n      }\n  \n    }\n    \n    /* <---------------------------- media query for ipad pro devices -------------------------------------> */\n    @media only screen and (min-width: 767px) and (max-width: 2000px) {\n  .parent-header{\n    height:8vh;\n    padding: 0px 36px !important;\n  }\n    }\n    @media (min-width: 576px){\n   .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n    left: unset;\n    right: 10px;\n}}\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
